import { motion } from "framer-motion";

const chapters = [
  {
    n: "01",
    title: "Built for the send",
    body: "No half measures. Heavyweight 220gsm combed cotton that holds its shape through every summit, session and late night.",
  },
  {
    n: "02",
    title: "One graphic, three moods",
    body: "The FULL SEND mountain mark — hand-drawn brush strokes rendered across black, navy and red. Pick your terrain.",
  },
  {
    n: "03",
    title: "Made in Nairobi",
    body: "Printed and packed in Kenya. Fast local delivery — place your order and we finish it with you on Instagram. Wear it loud.",
  },
];

const Manifesto = () => {
  return (
    <section id="manifesto" className="border-b border-[var(--line)] py-24 md:py-40">
      <div className="mx-auto max-w-[1600px] px-6 md:px-12">
        <motion.h2
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
          className="font-anton uppercase text-5xl md:text-7xl tracking-tighter mb-20 max-w-3xl leading-[0.9]"
        >
          Not just a shirt. <span className="text-[var(--accent)]">A statement.</span>
        </motion.h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-px bg-[var(--line)] border border-[var(--line)]">
          {chapters.map((c, i) => (
            <motion.div
              key={c.n}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.7, delay: i * 0.12, ease: [0.22, 1, 0.36, 1] }}
              className="bg-[var(--bg)] p-8 md:p-12 hover:bg-[var(--surface)] transition-colors group"
            >
              <span className="font-anton text-6xl md:text-7xl text-[var(--accent)] block mb-8 group-hover:translate-x-2 transition-transform">
                {c.n}
              </span>
              <h3 className="font-anton uppercase text-2xl md:text-3xl mb-4 tracking-tight">
                {c.title}
              </h3>
              <p className="text-[var(--text-dim)] leading-relaxed">{c.body}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Manifesto;
